module.exports = __webpack_public_path__ + "img/hand-heart.6b724f1a.svg";